import { SnowplowService } from 'wanderu-service-analytics';

const sendEvent = (action, label, properties) => SnowplowService.fireStructuredEvent({
    action,
    category: 'carousel',
    label,
    properties,
});

const clickSlide = (properties) => sendEvent('click', 'slide', properties);
const clickNext = (properties) => sendEvent('click', 'next', properties);
const clickPrev = (properties) => sendEvent('click', 'prev', properties);

const events = {
    clickNext,
    clickPrev,
    clickSlide,
};

export default events;
